<template>
  <div class="form-group esma_form_group">
    <div v-if="labelNewLine" class="col-xs-12" style="padding:1px 0px 1px 0px;">
      <label v-if="showLabel && hideAll == false" v-bind:for="fieldID" class="col-xs-2 control-label esma_form_label">{{fieldLabel}}</label>
    </div>
    <br v-if="labelNewLine">
    <label
    v-if="showLabel && labelNewLine == false && hideAll == false"
    v-bind:for="fieldID"
    :class="{'col-xs-2':showLabelAs4==false,'col-xs-4':showLabelAs4, 'control-label':true, 'esma_form_label':true,'esma_error_field':showAsError}"
    >{{fieldLabel}} <span v-if="isRequired" class="is_required" aria-hidden="true">＊</span></label>
    <div :class="fieldClass" style="padding:1px 0px 1px 7px;">
      <textarea
      v-show="hideAll == false"
      ref="local_value"
      v-bind:style="filedStyle"
      :disabled="this.localRefreshSequecnce > 0 && isDisabled && forcewrite == false"
      v-on:input="updateValue($event.target.value)"
      v-bind:id="fieldID"
      v-bind:name="fieldID"
      v-bind:value="fieldValue"
      class="form-control"
      placeholder=""
      :rows="fieldRows"
      ></textarea>
      <span
          v-show="hideAll == false"
          style='
            font-size: 15px;
            font-weight: 800;
            letter-spacing: 1px;
            color:red;'>{{fieldMessage}}</span>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      local_value : null,
      local_refresh_sequecnce: 1,
      show_as_error:false,
      hide_all:false,
      force_write:false
    }
  },


  computed: {
    fieldMessage() {
      return  this.$props.data.field_message || ""
    },
    hideAll:{
      get(){
        return this.hide_all;
      },
      set(v){
        this.hide_all = v;
      }
    },
    forcewrite:{
      get(){
        return this.force_write;
      },
      set(v){
        this.force_write = v;
      }
    },
    showLabelAs4(){
      return this.$props.data.label_length_4 == true || false
    },
    isRequired(){
        return this.$props.data.error_if_blank || this.$props.data.error_if_blank || false;
    },
    showAsError:{
      get(){
        return this.show_as_error;
      },
      set(v){
        this.show_as_error = v;
      }
    },
    localRefreshSequecnce:{
       get(){
         return this.local_refresh_sequecnce;
       },
       set(v){
         this.local_refresh_sequecnce = v;
       }
     },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    fieldClass(){
      if(this.getOption("hide_label",false)==true || this.getOption("label_in_new_line",false)==true){
        return "col-xs-12"
      }else{
        if(this.showLabelAs4 == true){
          return "col-xs-8"
        }else{
          return "col-xs-10"
        }
      }
    },
    fieldLabel() {
      return  this.$props.data.label
    },
    fieldValue() {
      return (this.localRefreshSequecnce > 0) ? this.$store.state[this.stateCurrentRow][this.fieldID]:"";
    },
    fieldRows(){
      return this.getOption("rows",3)
    },
    showLabel(){
      if(this.getOption("hide_label",false)==true){
        return false
      }else{
        return true
      }
    },
    labelNewLine(){
      return this.getOption("label_in_new_line",false)
    },
    fieldTableName() {
      return this.$props.data.table_name
    },
    fieldID() {
      return this.$props.data.id
    },
    isDisabled(){
      var ret = this.localRefreshSequecnce > 0 && (this.$props.data.disabled ||  this.$props.read  || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == "undefined")
      return ret;
    },

    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      var h = this.fieldRows * 20;
      return (this.getOption("field_style", this.$props.data.field_style || "height: "+h+"px !important;") || "") + store_style;
    }

  },
  methods:{
    refresh_hide_force(){
      this.hideAll = this.$props.data.hide_all == true;
      this.forcewrite = this.$props.data.force_write == true;
    },
    onClick(b){
      if(b.type=="add_to_input"){
          this.$refs.local_value.value = b.text
          this.$store.state[this.stateCurrentEditing][this.fieldID] = b.text
      }
      if(b.type=="link"){
          this.$router.push(b.link)
      }
      return false
    },
    updateValue(d){
      this.$store.state[this.stateCurrentEditing][this.fieldID] = d;
    },
    getOption(name,def){
      if(typeof this.$props.option[name] == "undefined"){
        return def
      }
      return this.$props.option[name]
    }
  },
  mounted() {
    this.$props.data.ref_field = this;
    this.refresh_hide_force();

    this.$props.data.on_field_messages = (vm,msg,cb) =>{
      if(msg && msg.msg_type == "error"){
        if(msg.show_as_error_mode == false && this.showAsError == false){
          return cb(false);
        }
        var local_val = _.clone(this.$store.state[this.stateCurrentEditing][this.fieldID]);
        if(typeof local_val == "undefined"){
          local_val = _.clone(this.$store.state[this.stateCurrentRow][this.fieldID]);
        }
        if(msg.show_as_error_mode && msg.only_if_enabled == true && this.isDisabled == true){
          this.showAsError = false;
          this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
          this.updateValue(local_val);
          this.localRefreshSequecnce++;
          return cb(false);
        }
        this.showAsError = msg.show_as_error_mode || false;
        this.$store.state[this.stateCurrentRow][this.fieldID] = local_val;
        this.updateValue(local_val);
        this.localRefreshSequecnce++;

        return cb(true);
      }
    }
  },
  props: ['data','value','option','read']
}
</script>
<style scoped>
.is_required{
  color:red;
}
.esma_error_field {
  color:red;
}
.form-control[disabled],  fieldset[disabled] .form-control {
  background-color: #cccccc;
}
.form-control::selection {
  color: white;
  background: #575757;
}
.form-control {
  color:black;
  width: 100%!important;
}
</style>


// WEBPACK FOOTER //
// text-area.vue?354aac8e